<template>
  <div class="introduce" :class="cssType">
    <div class="introduce-title" :class="locale"></div>
    <div class="introduce-content" :class="locale">
      <span class="introduce-content-part" v-for="text in introduceTexts" :key="text">
        <span v-html="text"></span>
        <br />
      </span>
    </div>
  </div>
</template>
<script setup>
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
const { locale, t } = useI18n()
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
console.log(payUrl, 'payUrl')
const cssType = isMobile ? 'mobile' : 'pc'
const introduceTexts = computed(() => {
  const text = t('accumRecharge.introduce')
  const texts = text.split('\n')
  const textList = texts.map(text => {
    if (text.includes('[clickHere]')) {
      text = text.replace('[clickHere]', `
      <a href="${payUrl.value}" class="act-link" target="_blank">
        [${t('accumRecharge.clickHere')}]
      </a>
      `)
    }
    return text
  })
  return textList
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>